import { AccessGuard } from '@vfde-fe/ngx-lib/guards/access-guard';
import { AccordionInterceptor, AccordionService } from '@vfde-fe/ngx-lib/components/accordion';
import { AuthenticationGuard } from '@vfde-fe/ngx-lib/guards/authentication';
import { ConfirmDataLossService } from '@vfde-fe/ngx-lib/services/confirm-data-loss';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { SpinnerService } from '@vfde-fe/ngx-lib/components/spinner';
import { StepperService } from '@vfde-fe/ngx-lib/components/stepper-module';
import { TrackingInterceptor } from '@vfde-fe/ngx-lib/plugins/tracking';
import { PageScrollService } from 'ngx-page-scroll-core';
import { DisableDeepLinksGuard } from './common/authentication/disable-deeplinks.guard';
import { HelperUtilsService } from './common/utils/helper-utils.service';
import { ProcessService } from './common/utils/process.service';
import { RoutesService } from './common/utils/routes.service';
/* this file for separating the service Providers which will be used through the entire application */
import { ValidationService } from './common/utils/validation.service';
import { InfoIconService } from '@vfde-fe/ngx-lib/components/info-icon';

/** APP_PROVIDERS */
export const APP_PROVIDERS = [
    RoutesService,
    ProcessService,
    ValidationService,
    AuthenticationGuard,
    AccessGuard,
    DisableDeepLinksGuard,
    HelperUtilsService,
    PageScrollService,
    ConfirmDataLossService,
    // ConfigLoaderService,
    CustomErrorHandlerService,
    AccordionService,
    SpinnerService,
    TrackingInterceptor,
    PageScrollService,
    AccordionInterceptor,
    StepperService,
    InfoIconService,
];
